<template>
  <b-container>
    <b-row>
      <b-col xl="10" offset-xl="1" class="formGeneric">
        <b-form>
          <b-form-group
            horizontal
            breakpoint="lg"
            label-size="lg"
            label-class="break-label"
          >
            <b-form-group
              id="ruledBy"
              horizontal
              label-class="text-sm-right"
              label-cols="3"
              label="ruledBy"
              label-for="ruledByField"
            >
              <b-form-select
                id="ruledByField"
                v-model="ruleBy"
                :options="ruleByArr"
                size="sm"
                class="mt-3"
              />
            </b-form-group>
            <b-form-group
              v-if="ruleBy"
              id="ruledByOptions"
              horizontal
              label-class="text-sm-right"
              label-cols="3"
              label="ruledBy options"
              label-for="ruledByOptionsField"
            >
              <b-form-select
                id="ruledByOptionsField"
                v-model="selectedOption"
                :options="ruleByOptions"
                size="sm"
                class="mt-3"
                @input="saveToStore"
              />
            </b-form-group>
            <form-error field-name="ruledBy" :errors="requiredErrors" />
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { axiosCall } from "../../../../utils/axiosCall";
import FormError from "../../../template/_template-error";
import { mapGetters } from "vuex";

export default {
  name: "ConfigurationWizardAccessControls",
  components: { FormError },
  props: {
    accountRoleTemplate: {
      type: String,
      default: "",
    },
    businessName: {
      type: String,
      default: "",
    },
    shouldSaveToStore: {
      type: Boolean,
      default: true,
    },
    storeIndex: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      ruleBy: null,
      selectedOption: null,
      ruleByArr: [],
      ruleByOptions: [],
      requiredErrors: [],
    };
  },
  created: async function () {
    await this.getInfo(true);
  },
  methods: {
    getStoreDataAccessControls: async function () {
      await this.getRuledBy();
      const _ = require("lodash");
      let storeInfo = _.cloneDeep(
        this.$store.getters.getStoreInfo("roleTemplates")
      );
      if (storeInfo) {
        if (this.storeIndex !== -1) {
          storeInfo = storeInfo[this.storeIndex];
        }
      }
      if (storeInfo) {
        this.selectedOption = storeInfo.ruledByValue;
        this.ruleBy = storeInfo.ruledBy;
      }
    },
    saveToStore() {
      if (this.shouldSaveToStore) {
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = "roleTemplates";
        payload["storeIndex"] = this.storeIndex;
        payload["data"]["ruledBy"] = this.ruleBy;
        payload["data"]["ruledByValue"] = this.selectedOption;
        this.$store.dispatch("setStoreInfo", payload);
      }
      this.validFormControls();
    },
    getRuledBy: async function (call = true) {
      if (call) {
        this.ruleByOptions = [];
        switch (this.ruleBy) {
          case "ruleByTagId":
            if (this.shouldSaveToStore) {
              if (this.getAllStoreInfo && this.getAllStoreInfo.tagsToCreate) {
                this.ruleByOptions = [
                  ...this.ruleByOptions,
                  ...this.getAllStoreInfo.tagsToCreate.map((tag) => ({
                    text: tag.name,
                    value: { ...tag, new: true },
                  })),
                ];
              }
              if (
                this.getAllStoreInfo &&
                this.getAllStoreInfo.tags &&
                this.getAllStoreInfo.tags.selected
                &&
                this.getAllStoreInfo.tags.selected.length
              ) {
                this.ruleByOptions = [
                  ...this.getAllStoreInfo.tags.selected.map((tag) => ({
                    text: tag.name,
                    value: { ...tag, new: true },
                  })),
                  ...this.ruleByOptions,
                ];
              }
            } else {
              await axiosCall({
                url: `Tags`,
                method: "get",
              }).then((response) => {
                response.data.map((tag) => {
                  this.ruleByOptions.push({ text: tag.name, value: tag.id });
                });
              });
            }
            break;
          case "ruleByCountry":
            await axiosCall({
              url: `Countries`,
              method: "get",
            }).then((response) => {
              response.data.map((country) => {
                this.ruleByOptions.push({
                  text: country.country,
                  value: country.id,
                });
              });
            });
            break;
          case "ruleByRegion":
            await axiosCall({
              url: `Tags`,
              method: "get",
            }).then((response) => {
              response.data.map((tag) => {
                this.ruleByOptions.push({ text: tag.name, value: tag.id });
              });
            });
            break;
        }
      }
      /* if (this.ruleBy === 'ruleByTag') {
          if (this.businessName) {
            if (previousValue) this.ruleByOptions = this.ruleByOptions.filter(rbp => rbp.text !== previousValue)
            this.ruleByOptions.push({ text: this.businessName, value: 'new' })
          }
        }*/
    },
    validFormControls() {
      let valid = true;
      if (this.selectedOption && this.ruleBy) {
        this.requiredErrors = [];
        this.$forceUpdate();
      } else {
        this.requiredErrors = ["required"];
        this.$forceUpdate();
        valid = false;
      }
      return valid;
    },
    getInfo: async function (getFromStore = false) {
      this.ruleBy = null;
      this.selectedOption = null;
      if (this.accountRoleTemplate) {
        this.ruleByArr = [];
        const where = {};
        where["where"] = {};
        where["where"]["accountRoleTemplateId"] = this.accountRoleTemplate;
        await axiosCall({
          url: `accessControlTemplates?filter=` + JSON.stringify(where),
          method: "get",
        }).then((response) => {
          let tempArr = [];
          response.data.map((elem) => {
            Object.keys(elem).map((key) => {
              if (key.includes("ruleBy")) {
                tempArr.push(key);
              }
            });
          });
          tempArr = Array.from(new Set(tempArr));
          this.ruleByArr = tempArr.map((r) => {
            return { text: r, value: r };
          });
        });
        if (getFromStore) {
          await this.getStoreDataAccessControls();
        }
      }
      this.saveToStore();
    },
  },
  computed: mapGetters(["getAllStoreInfo"]),
  watch: {
    accountRoleTemplate: async function () {
      await this.getInfo();
    },
    ruleBy: async function () {
      await this.getRuledBy();
    },
    businessName: async function (ewValue, oldValue) {
      await this.getRuledBy(false, oldValue);
    },
    "getAllStoreInfo.tagsToCreate": {
      handler: async function () {
        await this.getRuledBy();
      },
      deep: true,
    },
    "getAllStoreInfo.tags": {
      handler: async function () {
        await this.getRuledBy();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
